import script from "./ProjectThumbnail.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectThumbnail.vue?vue&type=script&setup=true&lang=js"

import "./ProjectThumbnail.vue?vue&type=style&index=0&id=1e8a4b53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e8a4b53"]])

export default __exports__